// extracted by mini-css-extract-plugin
export default {"btn":"Header_btn__CC9j-","text":"Header_text__oES5v"};